let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { css } from '@emotion/react';
import { Element, Group, Text, tokens } from '@klarna/ui';
import { toSuperscriptChars } from 'features/marketingDisclosures/superscripts/toSuperscriptChars';
import { useDisclosureDocument } from 'features/marketingDisclosures/useDisclosureDocument';
const disclosureStyles = css(t || (t = _`
  max-width: 100%;

  p,
  p > *,
  a {
    font-size: ${0}px;
    line-height: ${0}px;
  }

  p,
  p > * {
    color: ${0};
  }

  a {
    color: ${0};
    font-weight: 500;
    text-decoration: underline;
  }

  a:hover,
  a:focus,
  a:visited {
    color: ${0};
  }
`), tokens.textSizes['text/desktop/xs'], tokens.lineHeights['body/desktop/xs'], tokens.colors.light['text/subtle'], tokens.colors.light['text/default'], tokens.colors.light['text/default']);
/**
 * One BFF-driven disclosure entry prefixed by its superscript. A leaf so
 * each entry owns its own `useDisclosureDocument` call and is skipped
 * when the current locale has no content for that name.
 *
 * Renders `documentToReactComponents` inline rather than routing through
 * the shared `Disclaimer` component: `Disclaimer` is scoped to the (lazy)
 * installments modal chunks, and sharing it here would drag
 * `@contentful/rich-text-react-renderer` into `commons`. See the
 * `contentfulRichText` cache group in `bundling/rspack/client.prod.mts`.
 */ const SuperscriptedDisclosure = ({ disclosureName, superscript })=>{
    const document = useDisclosureDocument(disclosureName);
    if (!document) return null;
    return /*#__PURE__*/ _jsxs(Group, {
        direction: "horizontal",
        gap: "space/4",
        alignVertical: "baseline",
        wrap: false,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "text/subtle",
                tag: "span",
                textToken: "body/xs",
                children: toSuperscriptChars(superscript)
            }),
            /*#__PURE__*/ _jsx(Element, {
                webOnlyProps: {
                    css: disclosureStyles
                },
                children: documentToReactComponents(document)
            })
        ]
    });
};
export default SuperscriptedDisclosure;
